export default "__VITE_ASSET__B7qh_wIL__"